module.exports = __webpack_public_path__ + "static/logo-006f87c1c1653290197ae67216aa01ba.png";